import { render, staticRenderFns } from "./ModalMinhaConta.vue?vue&type=template&id=94a37202"
import script from "./ModalMinhaConta.vue?vue&type=script&lang=js"
export * from "./ModalMinhaConta.vue?vue&type=script&lang=js"
import style0 from "./ModalMinhaConta.vue?vue&type=style&index=0&id=94a37202&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports